import { useCallback, useEffect, useState } from 'react';
import useNavigate from 'src/new_arch/navigation/useNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentUserWorkspaces } from 'src/actions/workspaces';
import { getCurrentUserOwnedWorkspaces } from 'src/selectors/workspaces';

import SplashScreen from '../SplashScreen/SplashScreen';

const UpgradeSubscription = () => {
	const [ isFetchingWorkspaces, setIsFetchingWorkspaces ] = useState( true );
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const fetchWorkspaces = useCallback( () => {
		( dispatch( fetchCurrentUserWorkspaces() ) as unknown as Promise<unknown> )
			.then( () => setIsFetchingWorkspaces( false ) );
	}, [ dispatch ] );

	const ownedWorkspaces = useSelector( getCurrentUserOwnedWorkspaces );

	useEffect( () => {
		if ( isFetchingWorkspaces ) return;

		if ( ownedWorkspaces.length === 0 ) {
			navigate.toHome()
		} else {
			navigate.toUpgradeWorkspaceSubscription( ownedWorkspaces[ 0 ].id );
		}
	}, [ isFetchingWorkspaces, ownedWorkspaces ] );

	useEffect( () => { fetchWorkspaces(); }, [ fetchWorkspaces ] );

	return <SplashScreen />;
};

export default UpgradeSubscription;
